import { motion } from "framer-motion";
import { FiPlay } from "react-icons/fi";
import { useEffect, useState } from "react";
import hero_img from "../assets/hero_section.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

const HeroSection = () => {
  const [elements, setElements] = useState([]);

  return (
    <div className="relative bg-gradient-to-br from-purple-50 to-blue-50 overflow-hidden">
      {/* Main Content */}
      <div className="mx-auto px-10 pt-5 grid grid-cols-1 md:grid-cols-2 gap-12 items-center justify-between">
        {/* Text Section */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.2 }}
        className="py-14"
        >
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-cyan-100 text-cyan-600 mb-6">
            <span className="w-3 h-3 rounded-full bg-cyan-500 mr-2"></span>
            <span className="text-sm font-medium">BEST IT SOLUTION PROVIDER</span>
          </div>

          <motion.h1
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.2 }}
            className="text-5xl md:text-6xl font-bold text-gray-900 mb-6"
          >
            Excellent IT Services for Your Success
          </motion.h1>

          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            className="text-gray-600 mb-8 text-lg"
          >
            Unlock your business potential with our cutting-edge IT solutions. 
            At AppNexts, we provide exceptional services designed to drive growth,
             enhance efficiency, and deliver long-term success
          </motion.p>

            <Link
            to="/our-services"
            className="inline-flex items-center px-6 py-3 bg-indigo-700 hover:bg-indigo-800 text-white rounded-md transition-colors"
          >
            Explore More <BsArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </motion.div>

        {/* Image Section */}
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.3 }}
          className="relative text-center"
        >
          <div className="absolute inset-0 rounded-full blur-3xl opacity-20" />
          <img
            src={hero_img}
            alt="IT Professional"
            className="relative z-10 object-cover mx-auto"
            
            
            
          />
        </motion.div>
      </div>
    </div>
  );
};

export default HeroSection;

